export const baseUrl = process.env.NODE_ENV === 'production' ? 'https://api.bizminder.co.in' : 'http://14.14.14.14';
export const addressTextAreaFormatValue = (value) => {
  let out = '';
  const lines = value.trim().replace(/\r?\n|\r/g, '||').split('||');
  lines.forEach((entry, index) => {
    const line = entry.trim();
    if (index === lines.length - 1) {
      if (line.charAt(line.length - 1) === ',') out += line.substr(0, line.length - 1);
      else out += line;
    } else if (line.charAt(line.length - 1) === ',') out += `${line} `;
    else out += `${line}, `;
  });

  return out;
};

export const getCurrencyFormattedValue = (value) =>
  value.toLocaleString('en-IN', {
    style: 'currency',
    currency: 'INR',
    currencyDisplay: 'symbol',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const monthsShortCodes = {
  0: 'Jan',
  1: 'Feb',
  2: 'Mar',
  3: 'Apr',
  4: 'May',
  5: 'June',
  6: 'July',
  7: 'Aug',
  8: 'Sep',
  9: 'Oct',
  10: 'Nov',
  11: 'Dec',
};

export const edlCourseTypeOptions = [
  { name: 'Engineering/MS', value: 'engineeringMs' },
  { name: 'MBA/PGPM', value: 'mbaPgpm' },
  { name: 'Medical', value: 'medical' },
  { name: 'Hotel Management', value: 'hotelManagement' },
  { name: 'Vocational', value: 'vocational' },
  { name: 'Certificate', value: 'certificate' },
  { name: 'Other', value: 'other' },
];



// WEBPACK FOOTER //
// ./src/utils/globals.js